// test1895
(1895 && 0);
